import {
  ElementRef,
  ForwardedRef,
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { Box, Input, TextInput } from '@bonanza-social/moonlight';
const addLeadingZero = (value: string) => value.replace(/\b([1-9])\b/g, '0$1');

function BirthDateField(
  { value, onValue, onSubmitEditing }: RegistrationFieldProps<'birthDate'>,
  _: ForwardedRef<TextInput>,
) {
  const dayRef = useRef<ElementRef<typeof Input>>(null);
  const monthRef = useRef<ElementRef<typeof Input>>(null);
  const yearRef = useRef<ElementRef<typeof Input>>(null);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  const onDayChange = useCallback((value: string) => {
    const day = value.replace(/[^0-9]/g, '').slice(0, 2);

    setDay(day);

    if (day.length === 2) {
      yearRef.current?.focus();
    }
  }, []);

  const onMonthChange = useCallback((value: string) => {
    const month = value.replace(/[^0-9]/g, '').slice(0, 2);

    setMonth(month);

    if (month.length === 2) {
      dayRef.current?.focus();
    }
  }, []);

  const onYearChange = useCallback((value: string) => {
    const year = value.replace(/[^0-9]/g, '').slice(0, 4);

    setYear(year);
  }, []);

  useEffect(() => {
    const [yearString, monthString, dayString] = value.split('-');

    setDay(dayString ? dayString : '');
    setMonth(monthString ? monthString : '');
    setYear(yearString ? yearString : '');
  }, []);

  useEffect(() => {
    onValue(`${year}-${addLeadingZero(month)}-${addLeadingZero(day)}`);
  }, [day, month, year]);

  return (
    <Box>
      <Box flexDirection="row" gap="space-200">
        <Input
          ref={monthRef}
          flex={1}
          autoFocus={true}
          keyboardType="numeric"
          autoComplete="birthdate-month"
          enterKeyHint="next"
          placeholderNS="registration"
          placeholderKey="monthLabel"
          value={month}
          onChangeText={onMonthChange}
        />
        <Input
          ref={dayRef}
          flex={1}
          keyboardType="numeric"
          autoComplete="birthdate-day"
          enterKeyHint="next"
          placeholderNS="registration"
          placeholderKey="dayLabel"
          value={day}
          onChangeText={onDayChange}
        />
        <Input
          ref={yearRef}
          flex={1}
          keyboardType="numeric"
          autoComplete="birthdate-year"
          enterKeyHint="go"
          placeholderNS="registration"
          placeholderKey="yearLabel"
          value={year}
          onChangeText={onYearChange}
          onSubmitEditing={onSubmitEditing}
        />
      </Box>
    </Box>
  );
}

export default memo(forwardRef(BirthDateField));
